import Api from 'App/api'

export const getServices = Api.get({
  controller: 'services',
  action: 'list',
})

export const getUserServices = Api.get({
  controller: 'services',
  action: 'listRequests',
})

export const requestService = Api.post({
  controller: 'services',
  action: 'request',
})

export const cancelServiceRequest = Api.post({
  controller: 'services',
  action: 'cancelRequest',
})
